import { Variants, Transition } from 'framer-motion';

// Page transition (new for global use)
export const pageTransition: Variants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

export const pageTransitionConfig: Transition = {
  duration: 0.3,
  ease: [0.22, 1, 0.36, 1],
};

// Staggered container animation
export const staggerContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    },
  },
};

// Fade up entrance animation
export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1], // Custom easing
    },
  },
};

// Reduced motion variants for accessibility
export const reducedMotionVariants: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
};

export const reducedMotionTransition: Transition = {
  duration: 0.01,
};

// === Venue-themed animation variants ===

// Float — gentle y-axis bob for decorative elements
export const float: Variants = {
  hidden: { opacity: 0, y: 0 },
  visible: {
    opacity: 1,
    y: [0, -12, 0],
    transition: {
      y: { duration: 4, repeat: Infinity, ease: 'easeInOut' },
      opacity: { duration: 0.6 },
    },
  },
};

// Roll — x translation + rotation for pool balls
export const roll: Variants = {
  hidden: { opacity: 0, x: -20, rotate: 0 },
  visible: {
    opacity: 1,
    x: [0, 30, 0],
    rotate: [0, 360, 720],
    transition: {
      x: { duration: 3, repeat: Infinity, ease: 'easeInOut' },
      rotate: { duration: 3, repeat: Infinity, ease: 'linear' },
      opacity: { duration: 0.6 },
    },
  },
};

// Bounce — scale pulse for kids elements
export const bounce: Variants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: [1, 1.08, 1],
    transition: {
      scale: { duration: 2, repeat: Infinity, ease: 'easeInOut' },
      opacity: { duration: 0.6 },
    },
  },
};

// Glow Pulse — opacity pulse for gaming elements
export const glowPulse: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: [0.6, 1, 0.6],
    transition: {
      opacity: { duration: 3, repeat: Infinity, ease: 'easeInOut' },
    },
  },
};

// Reduced motion versions of themed animations (static, no loop)
export const floatReduced: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.3 } },
};

export const rollReduced: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.3 } },
};

export const bounceReduced: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.3 } },
};

export const glowPulseReduced: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 0.8, transition: { duration: 0.3 } },
};
